module.exports = __webpack_public_path__ + "static/media/AgencyUserIconFilter.c628bb78.svg";